var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFrameCallback = useFrameCallback;
var _react = require("react");
var _FrameCallbackRegistryJS = _interopRequireDefault(require("../frameCallback/FrameCallbackRegistryJS"));
var frameCallbackRegistry = new _FrameCallbackRegistryJS.default();
function useFrameCallback(callback) {
    var autostart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var ref = (0, _react.useRef)({
        setActive: function setActive(isActive) {
            frameCallbackRegistry.manageStateFrameCallback(ref.current.callbackId, isActive);
            ref.current.isActive = isActive;
        },
        isActive: autostart,
        callbackId: -1
    });
    (0, _react.useEffect)(function() {
        ref.current.callbackId = frameCallbackRegistry.registerFrameCallback(callback);
        ref.current.setActive(ref.current.isActive);
        return function() {
            frameCallbackRegistry.unregisterFrameCallback(ref.current.callbackId);
            ref.current.callbackId = -1;
        };
    }, [
        callback,
        autostart
    ]);
    return ref.current;
}
